import React from 'react';

/**
 * Minimal shared context interface covering fields used by shared layout components
 * (Header, NavBar, FooterBar, BottomNavBar, ViewContainer).
 * Each ERP's ConfigurationContext is a superset of this interface.
 */
export interface IBaseConfigurationContext {
    companyId: string;
    configurationId: string;
    token: string;
    isInsideEmbark: boolean;
    basePath: string;
    hasError?: boolean;
    successfulSyncConfiguration?: boolean;
    setSuccessfulSyncConfiguration?: (_value: boolean) => void;
    initialConfiguration?: unknown;
    updatedConfiguration?: unknown;
}

const defaultBaseContext: IBaseConfigurationContext = {
    companyId: '',
    configurationId: '',
    token: '',
    isInsideEmbark: false,
    basePath: '',
};

export const BaseConfigurationContext = React.createContext<IBaseConfigurationContext>(defaultBaseContext);